import React from 'react';
import { motion } from 'framer-motion';
import { Blob } from './Blob';

interface FrameCardProps {
  image: string;
  title: string;
  subtitle?: string;
  price?: string;
  bullets?: string[];
  tag?: string;
  onClick?: () => void;
  framed?: boolean;
}

export const FrameCard: React.FC<FrameCardProps> = ({
  image,
  title,
  subtitle,
  price,
  bullets = [],
  tag,
  onClick,
  framed = true,
}) => {
  return (
    <motion.article
      onClick={onClick}
      className="relative bg-white p-8 rounded-2xl max-w-sm w-full cursor-pointer hover:shadow-lg transition-shadow"
      whileHover={{ y: -4 }}
    >
      {/* Floating blob behind card */}
      <Blob
        className="-z-10 w-64 h-64 right-6 top-4"
        style={{ opacity: 0.08 }}
      />

      <div className="flex flex-col gap-6">
        <div
          className={`relative ${
            framed ? 'p-6 border-2 border-[#0B0B0B] rounded-2xl' : 'rounded-2xl'
          }`}
        >
          <div className="w-full aspect-[4/3] bg-gray-100 rounded-md overflow-hidden">
            <img
              src={image}
              alt={title}
              className="object-cover w-full h-full"
            />
          </div>
          {tag && (
            <div className="absolute top-3 left-3 bg-white/90 border border-gray-100 px-3 py-1 rounded-md text-xs font-medium">
              {tag}
            </div>
          )}
        </div>

        <div className="flex flex-col gap-2">
          <h3 className="font-serif text-2xl leading-tight text-[#0B0B0B]">
            {title}
          </h3>
          <div className="flex items-center gap-3">
            {subtitle && (
              <p className="text-sm tracking-widest uppercase text-[#6B6970]">
                {subtitle}
              </p>
            )}
            {price && (
              <span className="ml-auto text-lg font-medium text-[#0B0B0B]">
                {price}
              </span>
            )}
          </div>

          {bullets.length > 0 && (
            <ul className="mt-3 flex flex-col gap-1 text-sm text-[#6B6970] list-disc list-inside">
              {bullets.map((bullet, i) => (
                <li key={i}>{bullet}</li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </motion.article>
  );
};
